<template>
  <div class="vcv-billing">
    <vcv-sidebar-navigation :navigation-items="billingNavigation" />

    <router-view />
  </div>
</template>

<script>
import VcvSidebarNavigation from '@/components/VcvSidebarNavigation';

export default {
  components: {
    VcvSidebarNavigation
  },

  data() {
    return {
      billingNavigation: [
        {
          routeName: 'billing-tariffs',
          title: this.$tr('common.navigation.rates'),
          isDisabled: false
        },
        { routeName: 'billing-bills', title: this.$tr('common.navigation.bills'), isDisabled: true }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.vcv-billing {
  background: $background;
  height: 100%;
  display: flex;

  @media screen and (max-width: 820px) {
    flex-direction: column;
    align-items: center;
  }
}
</style>
